import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';

import { Response } from '../../shared/models/response.model';
import { Référentiel } from './models/référentiel.model';
import { ReferentielCreateRequest } from './request/create-request';
import { ReferentielUpdateRequest } from './request/update-request';

@Injectable({
  providedIn: 'root',
})
export class RéférentielService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/référentiels';

  findAll(idCartographie?: string) {
    let params = new HttpParams();

    if (idCartographie) params = params.append('idCartographie', idCartographie);

    return this.#http.get<Response<Référentiel>>(this.BASE_URL, {
      params,
    });
  }

  findById(id: string) {
    return this.#http.get<Référentiel>(this.BASE_URL + '/' + id);
  }

  getUploadUrl(id: string, fileName: string): Promise<string> {
    return firstValueFrom(
      this.#http.get<{ uri: string }>(this.BASE_URL + '/' + id + '/diagnostic/' + fileName).pipe(map((res) => res.uri)),
    );
  }

  create(data: ReferentielCreateRequest) {
    return this.#http.post<Référentiel>(this.BASE_URL, data);
  }

  update(id: string, data: Partial<ReferentielUpdateRequest>) {
    return this.#http.put<string>(this.BASE_URL + `/${id}`, data);
  }

  export(idReférentiel: string): Observable<Blob> {
    return this.#http.get(this.BASE_URL + '/export/' + idReférentiel, {
      responseType: 'blob' as const,
    });
  }
}
